import { useState } from 'react';
import RemotasksExternalLink from 'react-scale/corp/components/UI/RemotasksExternalLink';
import { SubtaskAssignment } from './types';
import { makeStyles } from 'design-system';

const ClassicLidarSpeedAuditLinks = (props: { subtaskAssignment: SubtaskAssignment }) => {
  const styles = useSpeedAuditDialogStyles();
  const { subtaskAssignment } = props;

  const [iframeWidth, setIframeWidth] = useState(120);
  const [iframeHeight, setIframeHeight] = useState(75);

  const query = {
    sceneId: subtaskAssignment.subtask.task ?? subtaskAssignment.subtask._id,
  };

  const searchParams = new URLSearchParams(
    Object.entries(query).filter(([_, v]) => v !== undefined) as [string, string][],
  ).toString();
  return (
    <div className={styles.lidarLiteContainer}>
      <div className={styles.title}>
        <div className={styles.links}>
          <div>
            <a
              href={`/lidarlite/?${searchParams}&readOnly=1`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>View Task in LidarLite (Dashboard) (read only)</span>
            </a>
            , same view loaded below, once you are done, rate the task here on this page's footer.
          </div>
          <div>
            <RemotasksExternalLink path="/lidarlite/" query={{ ...query, readOnly: 1 }}>
              <span>View Task in LidarLite (Remotasks) (read only)</span>
            </RemotasksExternalLink>
            , once you are done, rate the task here on this page's footer.
          </div>
          <div>
            If you want to do a real attempt/review,{' '}
            <RemotasksExternalLink path="/tasks" query={{ ...query, forceClaim: 1 }}>
              <span>claim task directly in LidarLite (edit mode)</span>
            </RemotasksExternalLink>
            .
          </div>
        </div>
        <div className={styles.controls}>
          <div className={styles.input}>
            <div>Width</div>
            <input
              type="range"
              min="50"
              max="200"
              step={1}
              value={iframeWidth}
              onChange={e => setIframeWidth(Number(e.target.value))}
            />
          </div>
          <div className={styles.input}>
            <div>Height</div>
            <input
              type="range"
              min="50"
              max="200"
              step={1}
              value={iframeHeight}
              onChange={e => setIframeHeight(Number(e.target.value))}
            />
          </div>
        </div>
      </div>
      <iframe
        src={`/lidarlite/?${searchParams}&readOnly=1`}
        style={{ width: `${iframeWidth}vh`, height: `${iframeHeight}vh`, border: 'none' }}
      />
    </div>
  );
};

const useSpeedAuditDialogStyles = makeStyles(() => ({
  lidarLiteContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 8,
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  links: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left',
    gap: 8,
  },
  controls: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'right',
    gap: 8,
  },
  input: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'right',
    gap: 8,
  },
}));

export default ClassicLidarSpeedAuditLinks;
